// Крючки для мок-сервера в dev и безголовых прогонах. В prod пустые: main.tsx заполняет их только в режиме фикстур.
export const devHooks: { invoicePaid?: (orderId: string) => void } = {};
